import React, {useEffect, useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import styles from './ModalComponent.module.css'
import {useFormikContext} from "formik";
import getAddedLanguages from "./methods/getAddedLanguages";
import useInappStatus from "@hooks/useInappStatus";
import {GAME_QA_ROLE} from "@constants/ENV";
import {hasGroup} from "@utils/helpers/access";

function ModalAddLang({handleLanguage, localeIndex}) {
    const { values } = useFormikContext();

    const [show, setShow] = useState(false);
    const [checkboxFields, setCheckboxFields] = useState(getAddedLanguages(values.titles));
    const [checkboxFieldsClone, setCheckboxFieldsClone] = useState({});
    const [addLocaleBtn, setAddLocaleBtn] = useState(getAddLocaleBtnStatus(checkboxFields));
    const [checkboxValue, setCheckboxValue] = useState(false);
    const status = useInappStatus();
    const disabled = status === "Ready" || hasGroup(GAME_QA_ROLE);

    useEffect(() => {
        setCheckboxFields(getAddedLanguages(values.titles));
    }, [values])

    useEffect(() => {
        setAddLocaleBtn(getAddLocaleBtnStatus(checkboxFields));
    }, [checkboxFields])

    const handleShow = (event) => {
        setShow(true);
        setCheckboxFieldsClone(JSON.parse(JSON.stringify(checkboxFields)));
        event.currentTarget.blur();
        setCheckboxValue(false)
    };

    const handleClose = () => {
        setShow(false);
        setCheckboxFields(JSON.parse(JSON.stringify(checkboxFieldsClone)));
    }

    const handleConfirm = (event) => {
        setShow(false);
        handleLanguage(checkboxFields);
        setCheckboxFields(JSON.parse(JSON.stringify(checkboxFieldsClone)));
        event.currentTarget.blur();
    };

    const handleCheck = (event) => {
        let newArr = {}
        let item = event.target.value;

        for (let key in checkboxFields) {
            if(checkboxFields.hasOwnProperty(key)){
                if (key === item) {
                    newArr[key] = !checkboxFields[key];
                } else {
                    newArr[key] = checkboxFields[key];
                }
            }
        }

        setCheckboxFields(newArr);
        setAddLocaleBtn(getAddLocaleBtnStatus(newArr));
    };

    const handleSelectAll = (event) => {
        let newObj = {};
        setCheckboxValue(!checkboxValue);

        for (let key in checkboxFields ) {
            newObj[key] = !checkboxValue;
        }

        setCheckboxFields(newObj)
        setAddLocaleBtn(getAddLocaleBtnStatus(newObj));
        event.currentTarget.blur();
    }

    return (
        <>
            <Button
                className='addRemoveSalesBtn'
                disabled={addLocaleBtn ||
                    disabled ||
                    localeIndex.length > 31}
                variant="outline-primary"
                onClick={handleShow}>
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M8.50004 4.75421C6.70745 4.75421 5.25427 6.20739 5.25427 7.99997C5.25427 9.79256 6.70745 11.2457 8.50004 11.2457C10.2926 11.2457 11.7458 9.79256 11.7458 7.99997C11.7458 6.20739 10.2926 4.75421 8.50004 4.75421ZM6.25427 7.99997C6.25427 6.75967 7.25973 5.75421 8.50004 5.75421C9.74034 5.75421 10.7458 6.75967 10.7458 7.99997C10.7458 9.24027 9.74034 10.2457 8.50004 10.2457C7.25973 10.2457 6.25427 9.24027 6.25427 7.99997Z"
                        fill="#0D6EFD"/>
                    <path
                        d="M10.2965 1.34338C9.76853 -0.447793 7.23147 -0.447791 6.70353 1.34338L6.60968 1.66179C6.45246 2.19519 5.84321 2.44755 5.35487 2.18155L5.06336 2.02276C3.4235 1.12953 1.62953 2.9235 2.52276 4.56336L2.68155 4.85487C2.94755 5.34321 2.69519 5.95246 2.16179 6.10968L1.84338 6.20353C0.0522075 6.73147 0.0522088 9.26853 1.84338 9.79647L2.16179 9.89032C2.69519 10.0475 2.94755 10.6568 2.68155 11.1451L2.52276 11.4366C1.62953 13.0765 3.42349 14.8705 5.06335 13.9772L5.35487 13.8184C5.84321 13.5524 6.45246 13.8048 6.60968 14.3382L6.70353 14.6566C7.23147 16.4478 9.76853 16.4478 10.2965 14.6566L10.3903 14.3382C10.5475 13.8048 11.1568 13.5524 11.6451 13.8184L11.9366 13.9772C13.5765 14.8705 15.3705 13.0765 14.4772 11.4366L14.3184 11.1451C14.0524 10.6568 14.3048 10.0475 14.8382 9.89032L15.1566 9.79647C16.9478 9.26853 16.9478 6.73147 15.1566 6.20353L14.8382 6.10968C14.3048 5.95246 14.0524 5.34321 14.3184 4.85487L14.4772 4.56335C15.3705 2.92349 13.5765 1.12953 11.9366 2.02276L11.6451 2.18155C11.1568 2.44755 10.5475 2.19519 10.3903 1.66179L10.2965 1.34338ZM7.66273 1.6261C7.90879 0.7913 9.09121 0.791301 9.33727 1.6261L9.43112 1.94451C9.76845 3.08899 11.0757 3.63046 12.1235 3.05972L12.415 2.90094C13.1793 2.48463 14.0154 3.32074 13.5991 4.08501L13.4403 4.37653C12.8695 5.42433 13.411 6.73155 14.5555 7.06888L14.8739 7.16273C15.7087 7.40879 15.7087 8.59121 14.8739 8.83727L14.5555 8.93112C13.411 9.26845 12.8695 10.5757 13.4403 11.6235L13.5991 11.915C14.0154 12.6793 13.1793 13.5154 12.415 13.0991L12.1235 12.9403C11.0757 12.3695 9.76845 12.911 9.43112 14.0555L9.33727 14.3739C9.09121 15.2087 7.90879 15.2087 7.66273 14.3739L7.56888 14.0555C7.23155 12.911 5.92433 12.3695 4.87653 12.9403L4.58501 13.0991C3.82074 13.5154 2.98463 12.6793 3.40093 11.915L3.55972 11.6235C4.13046 10.5757 3.589 9.26845 2.44452 8.93112L2.1261 8.83727C1.2913 8.59121 1.2913 7.40879 2.1261 7.16273L2.44451 7.06888C3.58899 6.73155 4.13046 5.42433 3.55972 4.37653L3.40093 4.08501C2.98463 3.32073 3.82074 2.48463 4.58501 2.90093L4.87653 3.05972C5.92432 3.63046 7.23155 3.089 7.56888 1.94452L7.66273 1.6261Z"
                        fill="#0D6EFD"/>
                </svg>
                Manage locale
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add locales</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={styles.modalCheckboxWrapper}>
                        {Object.entries(checkboxFields).map((item, index) => {
                            if (item[0] !== 'en' && !checkboxFieldsClone[item[0]]) {
                                return (
                                    <Form.Check
                                        key={index}
                                        type='checkbox'
                                        id={`default-checkbox${index}`}>
                                        <Form.Check.Input
                                            checked={item[1]}
                                            type='checkbox'
                                            value={item[0]}
                                            className={'checkbox'}
                                            onChange={handleCheck}/>
                                        <Form.Check.Label htmlFor={`default-checkbox${index}`}>{item[0]}</Form.Check.Label>
                                    </Form.Check>
                                )
                            }
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer className={styles.modalFooter}>
                    <Button
                        variant="outline-primary"
                        onClick={handleSelectAll}>
                        {
                            checkboxValue ? "Clear All" : 'Select all'
                        }
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleConfirm}>
                        Done
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

function getAddLocaleBtnStatus(arr) {
    for (let key in arr ) {
        if (!arr[key]) {
            return false;
        }
    }
    return true;
}

export default ModalAddLang;
